// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var ContentOptionality$SmartcutsMacros = require("./ContentOptionality.bs.js");

function fromInputValue(value) {
  switch (value) {
    case "ContentAllowedToBeMissing" :
        return /* ContentAllowedToBeMissing */1;
    case "ContentMustBePresent" :
        return /* ContentMustBePresent */0;
    default:
      return Util$SmartcutsMacros.logAndRaiseJsError("Expected valid content optionality config value");
  }
}

var $$default = /* ContentMustBePresent */0;

var toInputValue = ContentOptionality$SmartcutsMacros.stringify;

exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
exports.toInputValue = toInputValue;
exports.fromInputValue = fromInputValue;
/* Util-SmartcutsMacros Not a pure module */
